import React, { Component } from 'react'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import StyleSheet from 'styles'
import Button from '@material-ui/core/Button'
import { connect } from 'react-redux'
import { ThirdPartyActions } from 'actionsets'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Dependent from 'containers/shared/Dependent'
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Link } from 'react-router-dom'

export class Show extends Component{

  constructor(props){
    super(props)
    ThirdPartyActions.bindActions(this)
  }


  get objectId(){
    return this.props.match.params.id
  }

  dependsOn(){
    return Promise.all([
      this.actions.show({id: this.objectId}),
    ])
  }

  dependenciesMet(){
    return this.props.requests.filter(r => r.type === ThirdPartyActions.SHOW).length === 0
  }

  renderCommissionRow = ({unitPrice, allocation: { id: allocationId, dealSheetId }}) =>
    <TableRow>
      <TableCell>
        {unitPrice}
      </TableCell>
      <TableCell>
        <Link to={`/deal_sheets/${dealSheetId}/allocations/${allocationId}`}>
          {allocationId}
        </Link>
      </TableCell>
    </TableRow>


  render = () =>
    <div style={{width: '100%'}}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant='h6' className={styles.headline}>Third Party: {this.props.thirdParty.name}</Typography>
        </Toolbar>
      </AppBar>
      <div className={styles.flex}>
        <Card className={styles.card}>
          <CardContent>
            <Typography variant='subtitle1'>Commissions</Typography>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Unit Price</TableCell>
                  <TableCell>Allocation</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {this.props.thirdParty.thirdPartyCommissions.map(this.renderCommissionRow)}
              </TableBody>
            </Table>
          </CardContent>
          <CardActions>
            <Button onClick={() => this.props.history.push('/third_parties')} style={{marginLeft: 'auto'}}>Close</Button>
          </CardActions>
        </Card>
      </div>
    </div>
}

const styles = StyleSheet({
  headline: {
    flex: 1
  },
  flex: {
    margin: 10,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    flex: 1,
    '@media(max-width: 500px)': {
      margin: 0
    }
  },
  wrapper: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  card: {
    maxWidth: 1180,
    flex: 1,
    width: '100%',
    boxSizing: 'border-box'
  },
})

export default connect(({thirdParties}) => thirdParties)(Dependent({loader: true, wrapperClassName: styles.wrapper})(Show))